import React from 'react';

const FotoVideographiePortfolio = () => {
  const projects = [
    {
      id: 1,
      title: "Turbine 19",
      description: "Professionelle Produktvideos für die Turbine 19 – moderne Industrieästhetik trifft auf hochwertige Videografie. Emotionale Bildsprache, die Produkte und Marke perfekt in Szene setzt.",
      image: "https://public.readdy.ai/ai/img_res/2befc571e84424fecfc0702f85eb115c.jpg",
      tags: ["Produktvideo", "Industriefilm", "Videografie"],
      category: "Produktvideo"
    },
    {
      id: 2,
      title: "Tischlerei Hasenbalg",
      description: "Imagefilm für die Tischlerei Hasenbalg – handwerkliche Präzision und Leidenschaft für Holz eindrucksvoll festgehalten. Ein Werbefilm, der Qualität, Tradition und Können erlebbar macht.",
      image: "https://readdy.ai/api/search-image?query=artisan%20carpentry%20workshop%20with%20master%20craftsman%20working%20on%20fine%20wooden%20furniture%2C%20warm%20atmospheric%20lighting%20highlighting%20beautiful%20wood%20grain%20texture%20and%20sawdust%20particles%20in%20the%20air%2C%20professional%20commercial%20film%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20cinematic%20warm%20golden%20tones%2C%20handcraft%20workshop%20atmosphere&width=400&height=300&seq=102&orientation=landscape",
      tags: ["Werbefilm", "Imagefilm", "Handwerk"],
      category: "Imagefilm"
    },
    {
      id: 3,
      title: "Restaurant Fotografie",
      description: "Stimmungsvolle Food-Fotografie für ein exklusives Restaurant – jedes Bild ein Geschmackserlebnis. Sorgfältig inszenierte Teller auf elegantem Hintergrund, die Appetit und Emotion wecken.",
      image: "https://readdy.ai/api/search-image?query=exquisite%20gourmet%20food%20photography%20of%20elegantly%20plated%20restaurant%20dish%20on%20dark%20marble%20surface%2C%20soft%20diffused%20studio%20lighting%20highlighting%20textures%20and%20vibrant%20colors%2C%20professional%20culinary%20photography%2C%20fine%20dining%20aesthetic%20with%20garnishes%20and%20sauces%20artfully%20arranged%2C%20restaurant%20atmosphere%2C%20shallow%20depth%20of%20field%20bokeh&width=400&height=300&seq=103&orientation=landscape",
      tags: ["Food Fotografie", "Restaurant", "Kulinarik"],
      category: "Food Foto"
    }
  ];

  return (
    <section className="py-32 bg-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#d1bc8a] text-sm uppercase tracking-[0.3em] font-light mb-6 block">
            Portfolio
          </span>
          <h2 className="text-5xl md:text-7xl font-bold text-white mb-6">
            Unsere
            <br />
            <span className="text-[#d1bc8a]">Projekte</span>
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto font-light">
            Eine Auswahl unserer kreativen Foto- und Videoprojekte für lokale Unternehmen
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {projects.map((project) => (
            <div
              key={project.id}
              className="group bg-zinc-900 rounded-2xl overflow-hidden hover:bg-zinc-800 transition-all duration-300 border border-zinc-800 hover:border-[#d1bc8a]/30"
            >
              <div className="relative overflow-hidden w-full h-64">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-110"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-[#d1bc8a]/90 text-black px-3 py-1 rounded-full text-sm font-medium">
                    {project.category}
                  </span>
                </div>

                <div className="absolute bottom-4 right-4 z-10">
                  <h3
                    className="text-xl sm:text-2xl lg:text-3xl text-white drop-shadow-lg"
                    style={{
                      fontFamily: '"Anton", sans-serif',
                      fontWeight: "normal",
                      letterSpacing: "0.05em"
                    }}
                  >
                    {project.title}
                  </h3>
                </div>

                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 bg-black/40">
                  <div className="bg-[#d1bc8a] px-6 py-3 rounded-full transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                    <span className="text-black font-semibold flex items-center">
                      <i className="ri-play-circle-line mr-2"></i>
                      Projekt ansehen
                    </span>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <h4 className="text-white font-semibold text-lg mb-2">{project.title}</h4>
                <p className="text-white/60 mb-4 line-clamp-3 text-sm leading-relaxed">
                  {project.description}
                </p>

                <div className="flex flex-wrap gap-2">
                  {project.tags.map((tag, tagIndex) => (
                    <span
                      key={tagIndex}
                      className="bg-zinc-800 text-white/70 px-2 py-1 rounded text-sm"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>


      </div>
    </section>
  );
};

export default FotoVideographiePortfolio;
